import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories } from '@/mocks/forum';

function HomeSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '爱情岛论坛',
        url: window.location.origin + __BASE_PATH__,
        logo: window.location.origin + __BASE_PATH__ + '/logo.png',
        description: '爱情岛论坛是一个专注于情感交流、恋爱话题与社区互动的中文社区平台，致力于为用户提供温暖真诚的情感交流空间。',
        sameAs: ['#', '#', '#'],
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '0571-88889999',
          contactType: 'customer service',
          email: 'hello@aiqingdao.com',
        },
      },
      {
        '@type': 'WebSite',
        name: '爱情岛论坛',
        url: window.location.origin + __BASE_PATH__,
        description: '最新、最热的情感交流、恋爱话题与社区互动内容汇聚平台。每日更新精彩帖子，让你第一时间获取社区动态。',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: window.location.origin + __BASE_PATH__ + '/category/{search_term}',
          },
          'query-input': 'required name=search_term',
        },
      },
      {
        '@type': 'WebPage',
        name: '爱情岛论坛首页 - 最新精彩内容汇聚',
        url: window.location.origin + __BASE_PATH__,
        description: '欢迎来到爱情岛论坛首页，这里汇聚最新、最热的情感交流、恋爱话题与社区互动内容。每日更新精彩帖子，让你第一时间获取社区动态。',
        isPartOf: { '@type': 'WebSite', name: '爱情岛论坛' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: window.location.origin + __BASE_PATH__ },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const featuredArticles = articles.filter((a) => a.isFeatured);
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
  const latestArticles = articles.filter((a) => a.isNew).slice(0, 6);

  return (
    <>
      <HomeSchema />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20romantic%20sunset%20scene%20with%20soft%20gradient%20sky%20in%20coral%20and%20peach%20tones%2C%20gentle%20clouds%2C%20abstract%20flowing%20lines%20like%20a%20watercolor%20painting%2C%20dreamy%20ethereal%20atmosphere%2C%20warm%20ambient%20light%2C%20no%20people&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
            alt="爱情岛论坛"
            className="absolute inset-0 w-full h-full object-cover"
            title="爱情岛论坛 - 让每一份情感都被温柔以待"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/50"></div>
          <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
              让每一份情感都被温柔以待
            </h1>
            <p className="text-base md:text-xl text-background-200 mb-8 leading-relaxed">
              在爱情岛论坛，分享你的情感故事，畅聊恋爱心得，与志同道合的朋友一起感受情感的力量
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/love-stories"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                探索精彩内容
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 font-medium hover:bg-background-50/15 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                了解更多
              </Link>
            </div>
            <div className="flex items-center justify-center gap-8 mt-10">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">120万+</p>
                <p className="text-xs md:text-sm text-background-300 mt-1">注册会员</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">800万+</p>
                <p className="text-xs md:text-sm text-background-300 mt-1">累计帖子</p>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">50万+</p>
                <p className="text-xs md:text-sm text-background-300 mt-1">日活跃用户</p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选推荐</h2>
              <p className="text-sm text-foreground-500 mt-1">编辑精选的优质内容，不容错过</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        <section className="w-full bg-background-100 py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门分类</h2>
                <p className="text-sm text-foreground-500 mt-1">选择你感兴趣的话题，发现更多精彩</p>
              </div>
              <Link
                to="/category/love-stories"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">{cat.name}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{cat.description}</p>
                  <span className="text-xs text-foreground-400">{cat.count} 篇帖子</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新内容</h2>
                  <p className="text-sm text-foreground-500 mt-1">每日更新，社区最新精彩帖子</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>

            <div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 sticky top-24">
                <div className="flex items-center gap-2 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500">
                    <i className="ri-fire-line text-lg text-background-50"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950">热门排行</h3>
                </div>
                <div className="flex flex-col gap-4">
                  {hotArticles.map((article, index) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="flex items-start gap-3 group cursor-pointer"
                    >
                      <span
                        className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                          index === 0
                            ? 'bg-primary-500 text-background-50'
                            : index === 1
                            ? 'bg-accent-500 text-background-50'
                            : index === 2
                            ? 'bg-secondary-500 text-background-50'
                            : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                          {article.title}
                        </p>
                        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-400">
                          <span>{article.views > 1000 ? `${(article.views / 1000).toFixed(1)}k` : article.views} 阅读</span>
                          <span>{article.comments} 评论</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-primary-500 py-16">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
              加入爱情岛论坛
            </h2>
            <p className="text-base md:text-lg text-primary-100 mb-8 leading-relaxed">
              加入超过120万会员的情感社区，分享你的故事，倾听他人的心声，一起成长
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button className="px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base">
                立即注册
              </button>
              <button className="px-8 py-3.5 rounded-full border-2 border-background-50/70 text-background-50 font-medium hover:bg-background-50/15 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base">
                了解更多
              </button>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}